import React from "react";
import { Col, Row } from "react-bootstrap";
import PackageCard from "../common/Cards/PackageCard";

export default function Packages() {
  const packages = [
    { title: "50 Pushes (com.50notification.push)", subtitle: "$11.49" },
    { title: "10 Pushes (com.10notification.push)", subtitle: "$2.79" },
    { title: "20 Pushes (com.20notification.push)", subtitle: "$5.19" },
    { title: "3 Pushes (com.3notification.push)", subtitle: "$0.99" },
    { title: "5 Pushes (com.5notification.push)", subtitle: "$1.49" },
  ];

  return (
    <Row>
      <Col md={12} className="py-3">
        <h4 className="dashheading">Packages</h4>
        <p className="dashsubheading">Just Push it.</p>
      </Col>

      <Col md={12} className="mb-3">
        <div className="head-border" />
      </Col>

      {packages.map((pkg, index) => (
        <Col key={index} md={4} className="mt-3">
          <PackageCard title={pkg.title} subtitle={pkg.subtitle} />
        </Col>
      ))}
    </Row>
  );
}
